import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: 'Search End User',
    url: '/user',
    iconComponent: { name: 'cil-user' },
  },
  {
    name: 'Marketing page',
    url: '/marketing',
    iconComponent: { name: 'cil-https' },
  },
  {
    name: 'Stream & Call Settings',
    url: '/streaming',
    iconComponent: { name: 'cilMediaPlay' },
  },
  {
    name: 'Settings',
    url: '/settings',
    iconComponent: { name: 'cilSettings' },
  },
   {
    name: 'Clients',
    url: '/clients',
    iconComponent: { name: 'cil-user' },
  },
   {
    name: 'Agents',
    url: '/agents',
    iconComponent: { name: 'cil-user' },
  }
];
